<template>
	<div class="content-scroll">
		<div class="content-box page">
            <el-tabs active-name="first" class="pageTitle">
				<el-tab-pane label="供应商列表" name="first"></el-tab-pane>
			</el-tabs>
            <el-button type="success" class="posTopBtn" size="small" @click="handleForm(false)" icon="el-icon-plus" title="新增">新增</el-button>

            <el-form ref="form" :inline="true" :model="filters" size="small">
                <el-form-item label="搜索条件" prop="company">
                    <el-input clearable v-model="filters.company" @change="searchPage"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" icon="el-icon-search" @click="searchPage()">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" class="el-icon-download" type="primary" @click="handleExport()">导出</el-button>
                </el-form-item>
              <el-form-item>
                <el-button size="small" class="el-icon-download" type="danger" @click="handleExportTemplate()">模板下载</el-button>
              </el-form-item>
                <el-form-item>
                    <el-upload
                        ref='import'
                        :action="root + uploadUrl"
                        :show-file-list="false"
                        :on-success="importSuccess"
                        :before-upload="beforeImportFile"
                        :on-error="handleError"
                        :headers="{'username': username }">
                        <el-button size="small" type="warning">供应商导入</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            
            <!--列表-->
            <el-table @sort-change="sortChange" :data="pageData" border v-loading="tLoading">
                <el-table-column prop="nbr" label="序号" width="130" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="company" min-width="150" label="公司名"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="companyType" label="公司类型"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="brandAbbr" label="公司品牌缩写"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="country" label="国家"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="products" label="主要经营产品"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="contact" label="主要联系人" min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="sex" label="性别" :formatter="sexFormatter"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="tel" label="电话/座机" min-width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="email" label="邮箱" min-width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="website" label="网址"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="communication" label="主要沟通方式"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="companyEstablishTime" label="公司成立时间" align="center"></el-table-column>
                <el-table-column label="操作" width="160" align="right" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" title="修改" @click="handleForm(true, scope.row)" icon="el-icon-edit"></el-button>
                        <el-button type="danger" size="mini" title="删除" @click="handleDel(scope.row)" icon="el-icon-delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <div class="toolbar" style="text-align: right;">
                <el-pagination @current-change="handleCurrentChange" background :current-page="filters.pageIndex"  :page-size="filters.pageSize" layout="total, prev, pager, next" :total="totalNum"></el-pagination>
            </div>

            <!--新增界面-->
            <el-dialog :title="saveType ? '供应商编辑':'供应商新增'" :visible.sync="aVisible" width="80%" :modal-append-to-body="true" :close-on-click-modal="false" top="10vh">
                <el-form :model="formData" :rules="formRules" label-width="180px" ref="formFileds" size="small">
                    <el-form-item label="公司名" prop="company" class="inlineForm w450">
                        <el-input clearable v-model="formData.company"></el-input>
                    </el-form-item>
                  <el-form-item label="公司品牌缩写" prop="brandAbbr" class="inlineForm w450">
                    <el-input clearable v-model="formData.brandAbbr"  onkeyup="this.value = this.value.toUpperCase()"></el-input>
                  </el-form-item>
                    <el-form-item label="公司类型" prop="companyType" class="inlineForm w450">
                        <el-input clearable v-model="formData.companyType"></el-input>
                    </el-form-item>
                  <el-form-item label="主要经营产品" prop="products" class="inlineForm w450">
                    <el-input clearable v-model="formData.products"></el-input>
                  </el-form-item>
                    <el-form-item label="联系人" prop="contact" class="inlineForm w450">
                        <el-input clearable v-model="formData.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="性别" prop="sex" class="inlineForm w450">
                      <el-select clearable size="small"  v-model="formData.sex" placeholder="请选择性别">
<!--                        <el-option v-for="item in sexOption" :label="item.value" :value="item.key" :key="item.key"></el-option>-->
                        <el-option label="女" :value="0"></el-option>
                        <el-option label="男" :value="1"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="电话/座机" prop="tel" class="inlineForm w450">
                        <el-input clearable v-model="formData.tel"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email" class="inlineForm w450">
                        <el-input clearable v-model="formData.email"></el-input>
                    </el-form-item>
                    <el-form-item label="国家" prop="country" class="inlineForm w450">
                        <el-input clearable v-model="formData.country"></el-input>
                    </el-form-item>
                    <el-form-item label="网址" prop="website" class="inlineForm w450">
                        <el-input clearable v-model="formData.website"></el-input>
                    </el-form-item>
                    <el-form-item label="主要沟通方式" prop="communication" class="inlineForm w450">
                        <el-input clearable v-model="formData.communication"></el-input>
                    </el-form-item>
                    <el-form-item label="公司成立时间" prop="companyEstablishTime" class="inlineForm w450">
                        <el-date-picker size="small" v-model="formData.companyEstablishTime" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input clearable type="textarea" :rows="2" v-model="formData.remark"></el-input>
                    </el-form-item>
                    <el-form-item label="名片" prop="visitingCard">
                        <el-upload
                            ref="upload"
                            class="upload-demo"
                            :action="root + uploadUrl"
                            :on-remove="handleRemove"
                            :on-success="handleSuccess"
                            :before-upload="beforeUpload"
                            :file-list="fileList"
                            :limit="1"
                            :headers="{'username': username }"
                            list-type="picture"
                            >
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5Mb</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click.native="aVisible = false">取消</el-button>
                        <el-button type="primary" @click="saveType ? formSubmit(updateUrl, formData) : formSubmit(addUrl, formData)" :loading="bLoading">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'ghlb',
    data() {
        return {
            pageUrl:'/customer/supplier/list/page',
            updateUrl:'/customer/supplier/saveOrUpdate',
            addUrl:'/customer/supplier/saveOrUpdate',
            deleteUrl:'/customer/supplier/remove',
            exportUrl:'/customer/supplier/export',
            exportTemplateUrl:'/customer/supplier/exportTemplate',
            importUrl:'/customer/supplier/import',
            /*sexOption:[
              {key:0,value:"女"},{key:1,value: "男"}
            ],*/
            filters:{
                pageSize: 10,
                pageIndex: 1,
                company:'',
            },
            
            formData:{
                communication:'',
                company:'',
                brandAbbr:'',
                companyType:'',
                companyEstablishTime:'',
                contact:'',
                country:'',
                email:'',
                sex: 0,
                id:'',
                products:'',
                remark:'',
                tel:'',
                website:'',
                visitingCard:'',
            },
            brand_Abbr:'',
            formRules: {
                company: [
                  { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                brandAbbr: [
                  { required: true, message: '请输入公司品牌缩写', trigger: 'blur' }
                ]
            },
            fileList: [],
        }
    },
    computed:{
        ...mapGetters(['username'])
    },
    methods: {
        sexFormatter(row,column) {
          if(row.sex == 0) {
            return "女"
          }
          if(row.sex == 1) {
            return "男"
          }
        },
        beforeUpload(file) {
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!file.name.includes("jpg") && !file.name.includes("png") && !file.name.includes("jpeg")) {
                this.$message.warning("只能上传jpg/png文件");
                return false;
            }
            if (!isLt5M) {
                this.$message.error('上传头像图片大小不能超过 5MB!');
                return false;
            }
        },
        handleForm(type, row) {
            this.aVisible = true;
            this.$nextTick(() => {
                this.$refs.formFileds.resetFields();
                this.formData.visitingCard = ''
                if (this.$refs.upload) {
                    this.$refs.upload.clearFiles();
                    this.fileList = [];
                }
                if (type) {
                    this.saveType = 1
                    this.formData.id = row.id
                    this.mergeObject(this.formData, row)
                    if(row.visitingCard){
                        this.fileList.push({
                            name: row.visitingCard,
                            url: row.visitingCard
                        })
                    }
                } else {
                    this.saveType = 0
                    delete this.formData.id
                    this.formData.sex = undefined
                }
            })
        },
    },
    created(){
        this.getPage()
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>